import React, {Component} from "react";
import PublicNavBar from "../../layouts/Home/HomeElements/PublicNavBar";
import PublicFooter from "../../layouts/Home/HomeElements/PublicFooter";
import Playlist from "../../layouts/Home/Playlists/Playlist";
import styled from "styled-components";

class PublicPlaylist extends Component {
  state = {
    producer: null,
  };

  render = () => {
    return (
      <div id={"inner"} style={{backgroundColor: "rgb(127, 127, 127)", paddingTop:60}}>
        <PublicNavBar  contentCreatorView={true} />
        <Playlist isPublic={true} token={this.props.match.params.token}/>
        <PublicFooter {...this.props}/>
      </div>
    );
  };
}

export default PublicPlaylist;
